// extracted by mini-css-extract-plugin
export default {"wrapper":"fQ","content":"gQ","firstSection":"hQ","text":"iQ","table":"jQ","tableText":"kQ","row":"lQ","column_2":"mQ","column_1":"nQ","column_3":"oQ"};
    if(module.hot) {
      // 1730991509042
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  